export default __webpack_public_path__ + "static/porcion_arroz-72d9e07167aeb90034fa0f0107e4f0ae.jpg";